<template>
  <div class="massaction-compliance-modal">
    <!-- start:: Modal Header -->
    <div class="modal-header-group">
      <div class="modal-header-container" style="margin-bottom: 24px;">
        <h4 class="modal-title">{{$t('common.signInAndOutUC')}}</h4>
      </div>
      <span class="top-header-title">{{ compliance.name.charAt(0).toUpperCase() + compliance.name.slice(1) }}</span>
      <svg
        class="close-btn"
        @click="$bvModal.hide('compliance')"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
          fill="#F46A6A"
        />
      </svg>
    </div>
    <!-- end:: Modal Header -->


    <p class="modal-sub-header">
      <!-- <template v-if="compliance.form_metadata.status"> -->
        <template v-if="compliance.form_metadata.isExpected && compliance.form_metadata.status && compliance.form_metadata.status == 'success'">
          {{ $tc("signInOut.complianceCompleted", 1) }}
        </template>
        <template v-else-if="(compliance.form_metadata.status && compliance.form_metadata.status == 'failed' || compliance.form_metadata.status == 'justified') && compliance.form_metadata.isExpected">
          {{ $tc("signInOut.complianceFailed") }}
        </template>
      <!-- </template> -->
      <template v-else>{{ compliance.type == "questionnaire" ? $tc("signInOut.questionnaireHeader", 1) : $tc("signInOut.complianceHeader", 1) }}</template>
    </p>
    <p class="action-by-style" v-if="compliance.form_metadata.isExpected">
      {{ getDate(compliance.updated_at) }}  &ensp;<b> • </b>&ensp;   {{ $t("common.by") }}
      {{ $t(`common.` + compliance.form_metadata?.actionByRole?.toLowerCase()).toLowerCase() }}&nbsp;<strong class="strong-txt">
        ({{ compliance.form_metadata.actionByName }})</strong
      >
    </p>
    <!-- <p class="compliance-name">
      {{ compliance.name.charAt(0).toUpperCase() + compliance.name.slice(1) }}
    </p> -->
    <!-- <p class="header-note">
      {{ $tc("signInOut.complianceHeader", 1) }}
    </p> -->
    <ul>
      <li
        v-for="(question, index) in compliance.form_metadata.questions"
        :key="question.body"
      >
        <template>

          <div v-if="question.content_type == 'IMAGE'" class="image-container vp-mt-40">
            <img v-viewer :src="question.attachment_url"/>
          </div>
          <div v-if="question.content_type == 'PDF'" class="pdf-container vp-mt-40 vp-mb-32">
            <div class="pdf-agr">
            <div class="pdf-con">
              <div class="d-flex align-items-center justify-content-between" style="padding: 20px 20px 0 24px;">
                <div style="max-width: 96%;">
                  <span class="cursor-pointer" @click="openPDF(question.attachment_url)">{{ getPDFName(question.attachment_url) }}</span>
                </div>
                <svg class="cursor-pointer" @click="openPDF(question.attachment_url)" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M14.0864 0C14.5903 4.31018e-08 14.9987 0.415294 14.9987 0.927585L14.9987 4.86299C14.9987 5.37528 14.5903 5.79058 14.0864 5.79058C13.5826 5.79058 13.1741 5.37528 13.1741 4.86299V3.16697L9.89333 6.50274C9.53706 6.86499 8.95942 6.86499 8.60314 6.50274C8.24687 6.1405 8.24687 5.55319 8.60314 5.19094L11.884 1.85517L10.2159 1.85517C9.71203 1.85517 9.30358 1.43988 9.30358 0.927584C9.30358 0.415294 9.71203 4.91633e-08 10.2159 6.22367e-09L14.0864 0Z" fill="#103F5E"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 3.77216C0 2.08096 1.3484 0.709961 3.01174 0.709961H6.52544C7.07989 0.709961 7.52936 1.16696 7.52936 1.73069C7.52936 2.29443 7.07989 2.75143 6.52544 2.75143H3.01174C2.4573 2.75143 2.00783 3.20843 2.00783 3.77216V11.938C2.00783 12.5018 2.4573 12.9588 3.01174 12.9588H11.0431C11.5975 12.9588 12.047 12.5018 12.047 11.938V8.36546C12.047 7.80173 12.4964 7.34473 13.0509 7.34473C13.6053 7.34473 14.0548 7.80173 14.0548 8.36546V11.938C14.0548 13.6292 12.7064 15.0002 11.0431 15.0002H3.01174C1.3484 15.0002 0 13.6292 0 11.938V3.77216Z" fill="#103F5E"/>
                </svg>
              </div>
              <hr style="border-top: 1px solid #C8C0C0; margin: 20px 0 0 0;">
              </div>
              <div class="iframe-con">
                <iframe 
                class="iframe-container"
                  :src="question.attachment_url + '#toolbar=0&navpanes=0&scrollbar=0'" 
                  width="100%" 
                  style="border:none;">
                </iframe>
              </div>
            </div>
          </div>
    

          <p v-if="question.content_type == 'TEXT'"
            class="question-body"
            style="line-height: 28px; word-wrap: break-word; margin-bottom: 32px"
            :style="{marginTop: index == 0 ? '40px' : ''}"
          >
            <template v-if="compliance.type == 'questionnaire'">{{
              `${index + 1} - `
            }}</template>
            
            <template v-if="!readMore[index]">
              {{ question.body.substring(0, 150) }}
            </template>
            
            <template v-if="readMore[index]">
              {{ question.body }}
            </template>

            <a
              class="read_more"
              v-if="!readMore[index] && question.body.length >= 200"
              @click="showMore(index)"
              >{{ $t('common.readMore') }}</a
            >
            <a class="read_more" v-if="readMore[index]" @click="showLess(index)"
            >{{ $t('common.readLess') }}</a
            >
          </p>

          <div class="signin-radios-container">
            <v-radio-group v-model="tempAnswers[index]">
              <v-radio
                @change="updateFinalAnswerModel(question.answers[0].text, index)"
                :value="question.answers[0].text"
                :label="question.answers[0].text"
                :color="!tempAnswers[index] || (compliance.form_metadata.isExpected && compliance.form_metadata?.actionByRole?.toLowerCase() == 'admin' && compliance.form_metadata.notes.length >= 20 && question.answers[0]?.desired == false && question.answers[0].text == tempAnswers[index]) ? '#103F5E' :
                ((compliance.form_metadata.isExpected && compliance.form_metadata.notes.length < 20) || (compliance.form_metadata.isExpected && compliance.form_metadata?.actionByRole?.toLowerCase() == 'user') || (!compliance.form_metadata.isExpected)) && question.answers[0]?.desired == false && question.answers[0].text == tempAnswers[index] ? '#F46A6A' : '#34C38F'"
                :class="{
                        'text-success': question.answers[0]?.desired == true && question.answers[0].text == tempAnswers[index],
                        'text-danger': ((compliance.form_metadata.isExpected && compliance.form_metadata.notes.length < 20) || (compliance.form_metadata.isExpected && compliance.form_metadata?.actionByRole?.toLowerCase() == 'user') || (!compliance.form_metadata.isExpected)) && question.answers[0]?.desired == false && question.answers[0].text == tempAnswers[index],
                      }"
              >
              </v-radio>
              <span class="response-err response-err-danger" v-if="((compliance.form_metadata.isExpected && compliance.form_metadata.notes.length < 20) || (compliance.form_metadata.isExpected && compliance.form_metadata?.actionByRole?.toLowerCase() == 'user') || (!compliance.form_metadata.isExpected)) && question.answers[0]?.desired == false && question.answers[0]?.text == tempAnswers[index]">{{ $t("signInOut.responseNotMeet") }} {{ $tc("signInOut.responseWithJustification", 1)}}</span>
              <span class="response-err" v-else-if="compliance.form_metadata.notes.length >= 20 && question.answers[0]?.desired == false && question.answers[0]?.text == tempAnswers[index] && compliance.form_metadata.isExpected">{{ $t("signInOut.responseNotMeet") }} {{ $tc("signInOut.responseWithJustification", 2)}}</span>

              <v-radio
                @change="updateFinalAnswerModel(question.answers[1].text, index)"
                :value="question.answers[1].text"
                :label="question.answers[1].text"
                :color="!tempAnswers[index] || (compliance.form_metadata.isExpected && compliance.form_metadata?.actionByRole?.toLowerCase() == 'admin' && compliance.form_metadata.notes.length >= 20 && question.answers[1]?.desired == false && question.answers[1].text == tempAnswers[index]) ? '#103F5E' :
                ((compliance.form_metadata.isExpected && compliance.form_metadata.notes.length < 20) || (compliance.form_metadata.isExpected && compliance.form_metadata?.actionByRole?.toLowerCase() == 'user') || (!compliance.form_metadata.isExpected)) && question.answers[1]?.desired == false && question.answers[1].text == tempAnswers[index] ? '#F46A6A' : '#34C38F'"
                :class="{
                        'text-success': question.answers[1]?.desired == true && question.answers[1].text == tempAnswers[index],
                        'text-danger': ((compliance.form_metadata.isExpected && compliance.form_metadata.notes.length < 20) || (compliance.form_metadata.isExpected && compliance.form_metadata?.actionByRole?.toLowerCase() == 'user') || (!compliance.form_metadata.isExpected)) && question.answers[1]?.desired == false && question.answers[1].text == tempAnswers[index],
                      }"
              >
              </v-radio>
              <span class="response-err response-err-danger" v-if="((compliance.form_metadata.isExpected && compliance.form_metadata.notes.length < 20) || (compliance.form_metadata.isExpected && compliance.form_metadata?.actionByRole?.toLowerCase() == 'user') || (!compliance.form_metadata.isExpected)) && question.answers[1]?.desired == false && question.answers[1]?.text == tempAnswers[index]">{{ $t("signInOut.responseNotMeet") }} {{ $tc("signInOut.responseWithJustification", 1)}}</span>
              <span class="response-err" v-else-if="compliance.form_metadata.notes.length >= 20 && question.answers[1]?.desired == false && question.answers[1]?.text == tempAnswers[index] && compliance.form_metadata.isExpected">{{ $t("signInOut.responseNotMeet") }} {{ $tc("signInOut.responseWithJustification", 2)}}</span>
              <!-- <hr
                v-if="i != data.form_metadata.questions.length"
                class="question-divider"
              /> -->
            </v-radio-group>
          </div>
          <!-- <b-form-group
            class="question-body input-wrapper custom-radios custom-activeRadio"
          > -->
            <!-- <b-form-radio-group
              class="align-column"
              v-model="tempAnswers[index]"
              @input="updateFinalAnswerModel($event, index)"
            >
              <b-form-radio
                class="first-radiocheck mb-3"
                :value="question.answers[0].text"
                :text="question.answers[0].text"
              >
                {{ question.answers[0].text }}
              </b-form-radio>

              <b-form-radio
                class="first-radiocheck"
                :value="question.answers[1].text"
                :text="question.answers[1].text"
              >
                {{ question.answers[1].text }}
              </b-form-radio>
            </b-form-radio-group> -->
            <hr class="questions-divider" />
          <!-- </b-form-group> -->
        </template>
      </li>
    </ul>

    <span
      class="compliance-note-label"
      v-if="compliance.form_metadata.notes.length"
      >{{ $tc("signInOut.complianceNote", 1) }} {{ isNotesOptional ? $t("common.optionalWithBrackets") : "" }}</span
    >
    <b-form-textarea
      :class="{
        'remove-padding':
          compliance.form_metadata.notes.length && showNotesLabel,
        'top-padding': compliance.form_metadata.notes.length && !showNotesLabel,
        'has-value': compliance.form_metadata.notes.length
      }"
      v-model="compliance.form_metadata.notes"
      class="note-textarea"
      :placeholder="$tc('signInOut.complianceNote', 1) + ' ' + (isNotesOptional ? $t('common.optionalWithBrackets') : '')"
      type="text"
      rows="4"
      no-resize
      maxlength="255"
    ></b-form-textarea>

    <p v-if="!isNotesOptional" class="fillin-note">
      <b>{{ $t("common.notes.note") }}:</b> {{ $t("signInOut.mandatoryNotes") }}
    </p>

    <hr class="vertical-line" />
    <div class="modal-actions-btns">
      <VpButton :text="compliance.form_metadata.isDirty ? updateBtnValue : fillInBtnValue" @click="onSubmit" :disabled="invalidQuestions || (compliance.form_metadata.isDirty && !modelIsTouched)" />
      <VpButton :text="$t('common.cancel')" :isDanger="true" @click="$bvModal.hide('compliance')" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      readMore: {},
      questions: [],
      compliance: {},
      notes: "",
      showNotesLabel: true,
      modelIsTouched: false,
      tempAnswers: [],
      metadataStatus: "",
    };
  },
  validations: {
    compliance: {
      form_metadata: {
        questions: {
          $each: {
            finalAnswers: {
              validateFinalAnswer: function (answer) {
                if (
                  answer?.desired == true ||
                  (answer?.desired == false &&
                    this.compliance.form_metadata.notes.length >= 20)
                )
                  return true;
                return false;
              },
            },
          },
        },
      },
    },
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
    ...mapGetters("i18N", ["getLanguage"]),
    fillInBtnValue(){
      return this.$t('signInOut.fillIn')
    },
    updateBtnValue(){
      return this.$t('common.update')
    },
    isNotesOptional() {
      let notesOpt = true;
      this.compliance.form_metadata.questions.forEach((question, index) => {
        const answerFound = question.answers.find(answer => answer.text == this.tempAnswers[index]);
        if (answerFound && answerFound.desired == false) notesOpt = false;
      });
      return notesOpt;
    },
    invalidQuestions() {
      let isInvalid = false;
      const answered = this.tempAnswers.filter(answer => !!answer);
      if (!answered.length) return true;
      this.compliance.form_metadata.questions.some(
        (question, index) => {
          const answer = this.tempAnswers[index];
          const selected = question.answers.find(ans => ans.text === answer);
          isInvalid = !isInvalid ? selected?.desired == false && this.compliance.form_metadata.notes.length < 20 : isInvalid;
        }
      );
      console.log('isInvalid', isInvalid);
      return isInvalid;
    },
  },
  watch: {
    "compliance.form_metadata.notes"() {
      this.modelIsTouched = true;
      let textArea = document.querySelector(".note-textarea");
      this.showNotesLabel = textArea?.scrollHeight > textArea?.clientHeight + 3;
    },
    "compliance.form_metadata.questions": {
      handler(_, newValue, oldValue) {
        if (newValue && Object.keys(newValue)?.length && JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
          this.modelIsTouched = true;
        } else {
          this.modelIsTouched = false;
        }
      },
      deep: true,
    },
  },
  beforeMount() {
    this.compliance = JSON.parse(JSON.stringify(this.getModalInfo));
    // this.compliance.form_metadata.questions.forEach(console.log)
    this.tempAnswers = this.compliance.form_metadata?.questions?.map(
      (question) => {
        return question.finalAnswers?.text ?? "";
      }
    );
    console.log("tempAnswers", this.tempAnswers);
  },
  methods: {
    // selectedAnswer(index) {
    //   const val = this.compliance.form_metadata.questions[index].answers[this.compliance.form_metadata.questions[index].answers.findIndex(item => item.text == this.tempAnswers[index])];
    //   this.isNotesOptional = val ? val.desired == true : true;
    //   return val;
    // },
    openPDF(link) {
      window.open(link, "_blank");
    },
    getPDFName(link) {
      const fileNameWithExt = link.substring(link.lastIndexOf("/") + 1);
      const fileName = fileNameWithExt.replace(".pdf", "");
      return fileName;
    },
    updateFinalAnswerModel(answerText, questionIndex) {
      const answeredQuestionObject = this.compliance.form_metadata.questions[
        questionIndex
      ].answers.find((question) => question.text == answerText);

      this.$v.compliance.form_metadata.questions.$each.$iter[
        questionIndex
      ].finalAnswers.$model = answeredQuestionObject;

    },
    showPdfFilePreview(url) {
      window.open(url, '_blank');
    },
    onSubmit() {
      this.metadataStatus = null;
      this.compliance.form_metadata.questions.forEach((question, questionIndex) => {
        const undesiredAnswer = question.answers.find(answer => answer.desired == false);
        if (undesiredAnswer && undesiredAnswer.text == this.tempAnswers[questionIndex]) this.metadataStatus = "justified";
      });
      if (!this.metadataStatus) this.metadataStatus = "success";
      this.compliance.form_metadata.isDirty = true;
      this.compliance.form_metadata.status = this.metadataStatus;
      if (this.compliance.allAction) {
        this.$emit(
          "massActionComplianceSubmit",
          this.compliance.form_metadata,
          this.compliance.id
        );
      } else {
        this.$emit(
          "complainceSubmit",
          this.compliance.form_metadata,
          this.compliance.userId,
          this.compliance.id
        );
      }

      this.$bvModal.hide("compliance");
    },
    getDate(date) {
      if (this.getLanguage === "ar")
        return moment
        .utc(date)
        .tz(moment.tz.guess())
        .locale('en') // Ensures numbers remain in English
        .format("DD/MM/YYYY - h:mm") + 
        (moment.utc(date).tz(moment.tz.guess()).format("A") === "AM" ? " ص" : " م");

      return moment
        .utc(date)
        .tz(moment.tz.guess())
        .format("DD/MM/YYYY - h:mm A");
    },
    showMore(id) {
      this.$set(this.readMore, id, true);
    },
    showLess(id) {
      this.$set(this.readMore, id, false);
    },
  },
};
</script>

<style lang="scss">
.modal-dialog-scrollable .modal-body {
  overflow-x: hidden;
  }
div#compliance {
  .vertical-line {
    margin: 40px 0 24px 0;
  }
  .first-radiocheck.mb-3.custom-control.custom-control-inline.custom-radio {
    label.custom-control-label {
      padding-top: 5px;
      padding-inline-start: 16px;
    }
  }
}
.massaction-compliance-modal {
width: 416px;
.btn-primary.disabled, .btn-primary:disabled {
    background-color: #9FB2BF;
}
.btn.disabled, .btn:disabled {
    opacity: 1;
}
  //Modal header
  .modal-header-group {
    width: 100%;
    text-align: center;
    margin: 0 auto 32px auto;
    span.top-header-title {
      font-weight: 700;
      font-size: 16px;
      line-height: 20px;
      text-align: center;
      color: #4A4A4A;
    }
  }

  .top-header-title {
    font-weight: 700;
    font-size: 20px;
    line-height: 20px;
    letter-spacing: 0.25px;
  }

  // .close-modal-btn {
  //   position: relative;
  //   bottom: 5px;
  //   inset-inline-start: 125px;
  // }

  .modal-sub-header {
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.25px;
    text-align: center;
    color: #4A4A4A;
  }

  .compliance-name {
    font-size: 16px;
    font-weight: 700;
    line-height: 19px;
    letter-spacing: 0em;
    text-align: start;
    color: #939393;
  }

  .header-note {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.25px;
    text-align: start;
    color: #606060;
    margin: 30px 0;
    opacity: 0.8 !important;
  }
  .question-body {
    font-size: 16px;
    font-weight: 600;
    line-height: 17px;
    letter-spacing: 0.25px;
    text-align: start;
    color: #4A4A4A;
    // opacity: 0.8 !important;
  }
  .fillin-note {
    font-size: 14px;
    font-weight: 400;
    line-height: 23px;
    letter-spacing: 0.25px;
    text-align: start;
    color: #787878;
    margin-top: 8px;
    margin-inline-start: 20px;
    // opacity: 0.8 !important;
    // margin: -18px 15px 20px 15px;
  }
  .note-textarea {
    background-color: #f2f2f2 !important;
    border-color: #f2f2f2 !important;
    width: 415px;
    height: 100px;
    border: none;
    resize: none;
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 22px;
    letter-spacing: 0.25px;
    color: #787878 !important;
    // opacity: 0.8 !important;
    border-radius: 4px;
    padding-inline-start: 20px !important;
  }
  .has-value {
    font-weight: 700 !important;
    color: #4A4A4A !important;
  }
  .remove-padding {
    padding-top: -10px !important;
  }
  .top-padding {
    padding-top: 26px !important;
  }
  .note-textarea::placeholder {
    position: relative;
    top: 4px;
  }
  // .compliance-fillin-btn {
  //   height: 44px;
  //   width: 415px;
  //   inset-inline-start: 0px;
  //   top: 0px;
  //   border-radius: 22px;
  //   background-color: #103f5e;
  //   border: 0;
  //   border-radius: 22px;

  //   font-size: 16px;
  //   font-weight: 700;
  //   line-height: 17px;
  //   letter-spacing: 0.25px;
  //   text-align: center;
  //   color: #ffffff;
  //   margin-top: 30px;
  // }
  .align-column {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 70px;
    margin-top: 15px;
  }

  .custom-control-label::before {
    width: 20px;
    height: 20px;
    background: #c7c7c7 !important;
    //margin-top: -7px;
    border: 0 !important;
  }

  .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #103f5e !important;
    z-index: 1;
    border: 4px solid #c7c7c7 !important;
  }
  .custom-activeRadio
    .custom-radio
    .custom-control-input:checked
    ~ .custom-control-label
    span {
    color: #103f5e;
  }
  .custom-radios.custom-activeRadio {
    margin-top: -10px;
  }
  .custom-activeRadio
    .custom-radio
    .custom-control-input:checked
    ~ .custom-control-label::after {
    display: none;
  }
  .question-divider {
    margin: 30px 0;
    color: #606060;
  }
  .compliance-note-label {
    position: absolute;
    margin-inline-start: 20px;
    margin-top: 10px;
    z-index: 2;
    color: #103f5e;
    font-size: 12px;
    // opacity: 0.8;

    font-weight: 700;

    line-height: 17px;
    letter-spacing: 0.25px;
    // opacity: 0.8;
  }
  .questions-divider {
    margin: 24px 0;
  }
  // .compliance-fillin-btn:disabled {
  //   background-color: #96abb8;
  // }
  .action-by-style {
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    letter-spacing: 0em;
    color: #4A4A4A;
    margin-bottom: 0;
    text-align: center;
    background: #F2F2F2;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    margin-top: 24px;

    .strong-txt {
      color: #4A4A4A;
      font-weight: 700 !important;
    }
  }
  .col-form-label {
    max-width: 377px !important;
    white-space: normal !important;
  }

  .read_more {
    width: 69px;
    height: 17px;
    inset-inline-start: 721px;
    top: 503px;

    font-weight: 700;
    font-size: 14px;
    line-height: 23.5px;
    text-decoration-line: underline !important;
    color: #2680eb;
  }

  .image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: auto;
    max-height: calc(100vh - 300px);
    margin: 0 auto;
    width: 100%;
    overflow: hidden;
    margin-bottom: 32px;
    background: #fff;
    
    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
      cursor: zoom-in;
    }
  }
}

.signin-radios-container {
  .v-input--radio-group__input {
    display: grid;
    gap: 24px !important;
  }
  .v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {
    margin-bottom: 0;
  }
  .text-danger label,
  .text-danger span {
    color: #f46a6a !important;
  }
  .text-success label,
  .text-success span {
    color: #34c38f !important;
  }
  // .text-success,
  // .text-danger {
  //   pointer-events: none;
  // }
}

.response-err {
  font-size: 14px;
  font-weight: 400;
  margin-top: -8px;
  color: #787878;
  text-align: start;
}
.response-err-danger {
  color: #f46a6a !important;
}
</style>
